import { useField } from "formik";
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { t } from '../services';
import { FormControl, InputLabel } from '@mui/material';

export function TimeInput(props) {
    const [field, meta, helpers] = useField(props.name);
    const { value } = meta;
    const { setValue } = helpers;
    const handleChange = newValue => {
      setValue(newValue);
    };

    return (
      <FormControl variant="standard">
        <InputLabel shrink htmlFor={props.name}>
          {props.label}
        </InputLabel>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
            style={{marginTop: "16px", marginBottom: "8px"}}
            id={props.id}
            value={value}
            autoOk
            onChange={handleChange}
            disabled={props.disabled}
            okLabel={t`ok`}
            cancelLabel={t`cancel`}
            InputLabelProps={{shrink: false}}
            />
      </LocalizationProvider>
      </FormControl>
    );
}
